import VueRouter from "vue-router";
import Vue from "vue";
import config from "./config";
// import store from "../store";

//1. 安装
Vue.use(VueRouter);

//2. 创建路由对象
var router = new VueRouter(config);
// 导航守位
router.beforeEach(function(to, from, next) {
  var supUser = localStorage.getItem("supUser");

  if (to.name !== "Login") {
    // 需要登录才能访问页面
    if (supUser) {
      next(); //允许进入
      console.log("supUser", supUser);
    } else {
      next({
        name: "Login",
      });
      console.log("supUser", supUser);
    }
  } else {
    next();
  }
});

export default router;
